import { UNIT_FIELD_TYPE, normalizeUnitFieldValue } from "@autodromo/units";
import type { ChannelUnit } from "../../s3";

interface ResolveUnitFieldValuesParams {
  /** Valores do registro, por nome de campo, já com os de tipo relacionado. */
  values: Record<string, unknown>;
  fieldTypes: Record<string, string>;
  resolveUnit: (unitId: string) => ChannelUnit | null;
}

/**
 * O campo de unidade guarda uma lista de ids, e registro salvo antes disso
 * guarda uma string solta. A receita recebe um id só: o primeiro que pertence
 * ao canal, o mesmo que a página exibe e o mesmo que ganha nó `AutoDealer`.
 */
export function resolveUnitFieldValues({
  values,
  fieldTypes,
  resolveUnit,
}: ResolveUnitFieldValuesParams): Record<string, unknown> {
  const resolved: Record<string, unknown> = { ...values };

  Object.keys(values).forEach((field) => {
    if (fieldTypes[field] !== UNIT_FIELD_TYPE) return;

    resolved[field] =
      normalizeUnitFieldValue(values[field]).find((id) => resolveUnit(id)) ??
      null;
  });

  return resolved;
}
